var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5833 7.5H13.3333V5.83332C13.3333 2.6168 10.7166 0 7.5 0C4.28344 0 1.66668 2.6168 1.66668 5.83332V7.5H0.41668C0.186367 7.5 0 7.68637 0 7.91668V18.3334C0 19.2525 0.747461 20 1.66668 20H13.3334C14.2525 20 15 19.2525 15 18.3333V7.91668C15 7.68637 14.8136 7.5 14.5833 7.5ZM8.74758 16.204C8.76059 16.3216 8.72277 16.4396 8.64383 16.5279C8.56488 16.6162 8.45176 16.6667 8.33336 16.6667H6.66668C6.54828 16.6667 6.43516 16.6162 6.35621 16.5279C6.27727 16.4396 6.23941 16.3216 6.25246 16.204L6.51531 13.8404C6.08848 13.5299 5.83336 13.0387 5.83336 12.5C5.83336 11.5808 6.58082 10.8333 7.50004 10.8333C8.41926 10.8333 9.16672 11.5808 9.16672 12.5C9.16672 13.0387 8.9116 13.5299 8.48477 13.8404L8.74758 16.204ZM10.8333 7.5H4.16668V5.83332C4.16668 3.99535 5.66203 2.5 7.5 2.5C9.33797 2.5 10.8333 3.99535 10.8333 5.83332V7.5Z",
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLock);
export default __webpack_public_path__ + "static/media/yellow-lock.5f559c7d8cfe1c522fad80f94de88ffa.svg";
export { ForwardRef as ReactComponent };